import Loadable from 'react-loadable';
import { RouteLoading } from './RouteLoading';

const PosPagamentoSolicitacaoKit = Loadable({
  loader: () => import('../views/PosPagamento/Upload'),
  loading: RouteLoading,
});
const PosPagamentoAcompanharSolicitacao = Loadable({
  loader: () => import('../views/PosPagamento/AcompanharSolicitacao'),
  loading: RouteLoading,
});
const RegraSolicitação = Loadable({
  loader: () => import('../views/PosPagamento/Parametrizacao/RegraSolicitacao'),
  loading: RouteLoading,
});
const NovaRegraSolicitação = Loadable({
  loader: () => import('../views/PosPagamento/Parametrizacao/RegraSolicitacao/NovaRegra'),
  loading: RouteLoading,
});
const NovaCredenciada = Loadable({
  loader: () => import('../views/PosPagamento/Parametrizacao/RegraSolicitacao/Credenciada'),
  loading: RouteLoading,
});
const AlterarEmail = Loadable({
  loader: () => import('../views/PosPagamento/Parametrizacao/AlterarEmail'),
  loading: RouteLoading,
});
const RelatorioPosPag = Loadable({
  loader: () => import('../views/PosPagamento/Relatorios'),
  loading: RouteLoading,
});
const RegistroDevolutiva = Loadable({
  loader: () => import('../views/PosPagamento/Upload'),
  loading: RouteLoading,
});
const Dashboard = Loadable({
  loader: () => import('../views/PosPagamento/Dashboard'),
  loading: RouteLoading,
});

const Analitico = Loadable({
  loader: () => import('../views/PosPagamento/Dashboard/Analitico'),
  loading: RouteLoading,
});

const AnaliseDevolutiva = Loadable({
  loader: () => import('../views/PosPagamento/AnaliseDash'),
  loading: RouteLoading,
})

const Visualizar = Loadable({
  loader: () => import('../views/PosPagamento/Visualizar'),
  loading: RouteLoading,
});

const Consulta = Loadable({
  loader: () => import('../views/PosPagamento/Consulta'),
  loading: RouteLoading,
});

const VisualizarContrato = Loadable({
  loader: () => import('../views/PosPagamento/VisualizarContrato'),
  loading: RouteLoading,
});

const VisualizarContratoProtocolo = Loadable({
  loader: () => import('../views/PosPagamento/Protocolo/Visualizar'),
  loading: RouteLoading,
});

const UploadConsulta = Loadable({
  loader: () => import('../views/PosPagamento/UploadConsulta'),
  loading: RouteLoading,
});

const ProtocoloEnvio = Loadable({
  loader: () => import('../views/PosPagamento/Protocolo/Envio'),
  loading: RouteLoading,
});

const ConsultaProtocolo = Loadable({
  loader: () => import('../views/PosPagamento/Protocolo/Consulta'),
  loading: RouteLoading,
});

const ConsultaSolicitacaoDocumentos = Loadable({
  loader: () => import('../views/PosPagamento/ConsultaSolicitacaoDocs'),
  loading: RouteLoading,
});

const SolicitacaoDocAprovador = Loadable({
  loading: RouteLoading,
  loader: () => import('../views/PosPagamento/Solicitacao/AprovarRejeitar'),
})

const SolicitacaoDocumento = Loadable({
  loader: () => import('../views/PosPagamento/Solicitacao/SolicitarDocs'),
  loading: RouteLoading,
});

const MonitorContrato = Loadable({
  loader: () => import('../views/PosPagamento/MonitorContratos'),
  loading: RouteLoading,
})

const AnaliticoContrato = Loadable({
  loader: () => import('../views/PosPagamento/AnaliticoContrato'),
  loading: RouteLoading,
});

const RoutePosPagamento = [
  {
    path: '/pos-pagamento/registro-contrato/solicitacao-kit',
    exact: true,
    name: 'Registro de Contrato / Solicitação de Kit',
    component: PosPagamentoSolicitacaoKit,
  },
  {
    path: '/pos-pagamento/registro-contrato/acompanhar-solicitacao',
    exact: true,
    name: 'Registro de Contrato / Acompanhamento de Solicitação',
    component: PosPagamentoAcompanharSolicitacao,
  },
  {
    path: '/pos-pagamento/parametrizacao/regra-solicitacao',
    exact: true,
    name: 'Parametrizacão / Regras Para Solicitação',
    component: RegraSolicitação,
  },
  {
    path: '/pos-pagamento/parametrizacao/regra-solicitaca/nova-regra',
    exact: true,
    name: 'Parametrizacão / Regras Para Solicitação / Nova Regra',
    component: NovaRegraSolicitação,
  },
  {
    path: '/pos-pagamento/parametrizacao/regra-solicitacao/editar-regra/:id',
    exact: true,
    name: 'Editar Regra',
    component: NovaRegraSolicitação,
  },
  {
    path: '/pos-pagamento/parametrizacao/regra-solicitacao/credenciada',
    exact: true,
    name: 'Credenciada',
    component: NovaCredenciada,
  },
  {
    path: '/pos-pagamento/parametrizacao/alterar-email',
    exact: true,
    name: 'Parametrizacão / Alterar Email',
    component: AlterarEmail
  },
  {
    path: '/pos-pagamento/relatorios',
    exact: true,
    name: 'Relatórios',
    component: RelatorioPosPag
  },
  {
    path: '/pos-pagamento/solicitacao-doc/aprovador',
    exact: true,
    name: 'Solicitação de Doc / Aprovador',
    component: SolicitacaoDocAprovador
  },
  {
    path: '/pos-pagamento/registro-contrato/registrar-devolutiva',
    exact: true,
    name: 'Registro de Contrato / Retorno DETRAN',
    component: RegistroDevolutiva
  },
  {
    path: '/pos-pagamento/registro-contrato/dashboard',
    exact: true,
    name: 'Registro de Contrato / Dashboard',
    component: Dashboard
  },
  {
    path: '/pos-pagamento/registro-contrato/dashboard',
    exact: true,
    name: 'Registro de Contrato / Dashboard'
  },
  {
    path: '/pos-pagamento/registro-contrato/dashboard',
    exact: true,
    name: 'Registro de Contrato / Dashboard',
    component: Dashboard
  },
  {
    path: '/pos-pagamento/registro-contrato/dashboard/analitico/:id',
    exact: true,
    name: 'Analítico',
    component: Analitico
  },
  {
    path: '/pos-pagamento/registro-contrato/analise-retorno-detran',
    exact: true,
    name: 'Registro de Contrato / Análise Retorno DETRAN',
    component: AnaliseDevolutiva
  },
  {
    path: '/pos-pagamento/registro-contrato/analise-retorno-detran/:id',
    exact: true,
    name: 'Analítico',
    component: Visualizar
  },
  {
    path: '/pos-pagamento/consulta',
    exact: true,
    name: 'Consulta de Contrato',
    component: Consulta,
  },
  {
    path: '/pos-pagamento/visualizar/:mode/:numeroContrato',
    exact: true,
    name: 'Consulta de Contrato / Visualizar Contrato',
    component: VisualizarContrato,
  },
  {
    path: '/pos-pagamento/protocolo/visualizar/:idProtocolo',
    exact: true,
    name: 'Protocolo / Consulta de Protocolo / Visualizar Protocolo',
    component: VisualizarContratoProtocolo,
  },
  {
    path: '/pos-pagamento/upload/:mode',
    exact: true,
    name: 'Consulta de Contrato / Upload',
    component: UploadConsulta,
  },
  {
    path: '/pos-pagamento/protocolo/envio-protocolo',
    exact: true,
    name: 'Protocolo / Envio de Protocolo',
    component: ProtocoloEnvio,
  },
  {
    path: '/pos-pagamento/protocolo/consulta-protocolo',
    exact: true,
    name: 'Protocolo / Consulta de Protocolo',
    component: ConsultaProtocolo,
  },
  {
    path: '/pos-pagamento/solicitacao-doc/consulta-solicitacao',
    exact: true,
    name: 'Solicitação de Docs / Consulta Solicitação',
    component: ConsultaSolicitacaoDocumentos,
  },
  {
    path: '/pos-pagamento/solicitacao-docs/:idContrato',
    exact: true,
    name: 'Consulta de Contrato / Solicitação de Documentos',
    component: SolicitacaoDocumento,
  },
  {
    path: '/pos-pagamento/monitor-contratos',
    exact: true,
    name: 'Monitor Contratos',
    component: MonitorContrato
  },
  {
    path: '/pos-pagamento/analitico-contrato/:tipoAnalitico',
    exact: true,
    name: 'Analítico Contratos',
    component: AnaliticoContrato,
  },
];

export { RoutePosPagamento };